import { tipoPlanoNomeCased } from "../../../../utils/constants";
import useInitialConfigStore from "../../../../storeModules/useInitialConfigStore";

const getFilteredPlansByTipoTabela = (plan, tipoTabela) => {
  return plan.planosTipos.filter((tipo) => {
    if (tipo.name) {
      switch (tipoTabela) {
        case "integral_pagametade":
          return (
            tipo.name.toUpperCase() ===
              tipoPlanoNomeCased.CREDITO_INTEGRAL.toUpperCase() ||
            tipo.name.toUpperCase() ===
              tipoPlanoNomeCased.CREDITO_PAGAMETADE.toUpperCase()
          );
        case "integral_reduzida":
          return (
            tipo.name.toUpperCase() ===
              tipoPlanoNomeCased.CREDITO_INTEGRAL.toUpperCase() ||
            tipo.name.toUpperCase() ===
              tipoPlanoNomeCased.PAGA_REDUZIDA.toUpperCase()
          );
        case "reduzida":
          return (
            tipo.name.toUpperCase() ===
            tipoPlanoNomeCased.PAGA_REDUZIDA.toUpperCase()
          );
        case "pagametade_reduzida":
          return (
            tipo.name.toUpperCase() ===
              tipoPlanoNomeCased.CREDITO_PAGAMETADE.toUpperCase() ||
            tipo.name.toUpperCase() ===
              tipoPlanoNomeCased.PAGA_REDUZIDA.toUpperCase()
          );
        default:
          return (
            tipo.name.replace(" ", "").toUpperCase() ===
            tipoTabela.replace("_", " ").toUpperCase()
          );
      }
    }
    return false;
  });
};

const handleSetPlansMap = (fetchedPlans, setPlansMap) => {
  const { tipoTabela } = useInitialConfigStore.getState();

  if (fetchedPlans.length > 1) {
    const filterByTipoTabela = fetchedPlans.map((plan) => {
      return {
        ...plan,
        planosTipos: getFilteredPlansByTipoTabela(plan, tipoTabela),
      };
    });

    const filterByNotEmptyPlans = filterByTipoTabela.filter(
      (plan) =>
        plan.planosTipos.length > 0 ||
        plan.planoCardType === "simular-novamente"
    );

    setPlansMap(filterByNotEmptyPlans);
  }
};

export default handleSetPlansMap;
